var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:{'large': _vm.size == 'large'}},[_c('b-img',{attrs:{"src":require('@/assets/ruble.png')}}),_c('p',{staticClass:"price"},[_vm._v(" "+_vm._s(_vm.price)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }